module.exports = __webpack_public_path__ + "static/img/9.644ae8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/imgs/9.png
// module id = 4qKk
// module chunks = 0